import { Box, Button, Card, Grid, Popover, TextField } from '@material-ui/core';
import React from 'react';
import { DateRangePicker } from '../../../components/DateRangePicker';
import { format } from 'date-fns';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const styles = {
  customSelect: {
    borderStyle: 'solid',
    borderColor: 'rgb(192, 192, 192)',
    borderWidth: 1,
    paddingLeft: '14px',
    fontSize: '14px',
    color: 'rgb(102, 120, 138)',
    cursor: 'pointer',
    height: '37.625px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textContainer: { whiteSpace: 'nowrap', overflow: 'hidden' },
  iconContainer: {
    width: '35px',
    display: 'flex',
    justifyContent: 'center',
  },
};

export function SelectPeriod({
  changeGlobalPeriodFromParent,
  defaultSelectDateRangeFromParent,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [globalStatePeriod, setGlobalStatePeriod] = React.useState(
    defaultSelectDateRangeFromParent
  );
  const [inputText, setInputText] = React.useState(
    `Custom: ${format(
      defaultSelectDateRangeFromParent.startDate,
      'dd/MM/yyyy'
    )} - ${format(defaultSelectDateRangeFromParent.endDate, 'dd/MM/yyyy')}`
  );

  function showDatePicker(event) {
    setAnchorEl(event.currentTarget);
  }

  function closeDatePicker() {
    setAnchorEl(null);
  }

  function changePeriodFn({ statePeriod }) {
    setGlobalStatePeriod(statePeriod);
  }

  function selectRange() {
    changeGlobalPeriodFromParent(globalStatePeriod);
    const text = `Custom: ${format(
      globalStatePeriod.startDate,
      'dd/MM/yyyy'
    )} - ${format(globalStatePeriod.endDate, 'dd/MM/yyyy')}`;
    setInputText(text);
    closeDatePicker();
  }

  return (
    <Box>
      <Card style={styles.customSelect} elevation={0} onClick={showDatePicker}>
        <div style={styles.textContainer}>{inputText}</div>
        <div style={styles.iconContainer}>
          <ArrowDropDownIcon />
        </div>
      </Card>
      <Popover
        id="select-date"
        open={Boolean(anchorEl)}
        onClose={closeDatePicker}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box display="flex" flexDirection="column">
          <DateRangePicker
            maxDate={new Date()}
            showMonthAndYearPickers={true}
            showMonthArrow={true}
            changePeriodFn={changePeriodFn}
            dateRangeFromParent={globalStatePeriod}
          />
          <Button size="small" color="primary" onClick={selectRange}>
            Generar
          </Button>
        </Box>
      </Popover>
    </Box>
  );
}
